/**
 *
 * Asynchronously loads the component for EventsPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
